import template from './sw-cms-block-image-text-bubble.html.twig';
import './sw-cms-block-image-text-bubble.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
